import { Category } from "./category";
import { Project } from "./project";

export class ConferenceConnection {
    id: number;
    projectId: number;   
    project:Project = new Project();
    categoryId: number;
    category = new Category(); 
}